import { L2RButton } from "../L2RButton/L2RButton"

type ButtonSubmitProps = {
    className?: string,
    children: React.ReactNode,
    isSubmitting?: boolean,
}

export function ButtonSubmit(props: ButtonSubmitProps) {
    const {
        className,
        children,
        isSubmitting = false,
        ...otherProps
    } = props

    return (
        <L2RButton
            {...otherProps}
            fullWidth
            type="submit"
            variant="primary"
            loading={isSubmitting}
            className={className}
        >
            {children}
        </L2RButton>
    )
}


